export const OfferMenus = {
    outgoing: [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            text: "labels.order.send_email",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) },
            click: function (data) { this.$emitter.emit("buttons:order:menu:sendmail"); }
        },
        {
            loading: false,
            key: "abort",
            text: "labels.invoice.menus.abort",
            emit: "kooi:mails:menu:abort",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check",
            emit: "kooi:offer:menu:accept",
            key: "accept",
            text: "labels.offer.menus.create_order"
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            key: "cancel",
            text: "labels.offer.menus.decline"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf", text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) }
        },
    ],
    rejected: [
        // {key:"sendOffer", text:"Reset and Send via E-Mail"},
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check",
            emit: "kooi:offer:menu:accept",
            key: "accept",
            text: "labels.offer.menus.accept_create_order"
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf", text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) }
        },
        // {key:"cancel",text:"Decline"}
    ],
    accepted: [
        // {key:"copy", text:"labels.offer.menus.copy"},
        // {key:"cancel",text:"Cancel"},
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.offer.menus.reject"
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) }
        },
    ],
    "open": [
        {
            disabled: false,
            loading: false,
            icon: "fas fa-clipboard-check",
            emit: "kooi:offer:menu:pdf_validation",
            key: "validatepdf",
            text: "labels.pdf.validation.pdf_validation",
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-file-pdf",
            emit: "kooi:offer:menu:openpdf",
            key: "openpdf",
            text: 'labels.order.download_pdf',
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-paper-plane",
            emit: "kooi:offer:menu:send_email",
            key: "sendmaibeneficialAccountl",
            text: "labels.order.send_email",
            function: function (data) { return (data && data.pdf && data.pdf.find(item => item.type == "offer") != undefined) }
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-check",
            emit: "kooi:offer:menu:accept",
            key: "accept",
            text: "labels.offer.menus.create_order"
        },
        {
            disabled: false,
            loading: false,
            key: "copy",
            text: "labels.offer.menus.copy"
        },
        {
            disabled: false,
            loading: false,
            icon: "fas fa-times",
            emit: "kooi:offer:menu:reject",
            key: "reject",
            text: "labels.offer.menus.reject"
        },
    ]
};
